import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Loader from "rsuite/Loader";
import { FilterCloseIcon } from "../../../Icons/icons.component";

export const TagNameModal = function ({
  show,
  onConfirm,
  onCancel,
  confirmButtonText,
  confirmText,
  error,
  modalTitle,
  editValue,
  modalLoader = false,
}) {
  const [tagName, setTagName] = useState("");
  useEffect(() => {
    if (editValue) {
      const { name } = editValue;
      if (name) {
        setTagName(name);
      }
    }
  }, []);

  return (
    <Modal
      show={show}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      className="customModalWrap"
    >
      <Modal.Header>
        <Modal.Title>{modalTitle}</Modal.Title>
        <button className="btnModalClose" onClick={() => onCancel(false)}>
          <FilterCloseIcon />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="formControlWrap">
          <input
            type="text"
            className="form-control"
            placeholder="Enter text here"
            onChange={(e) => setTagName(e.target.value)}
            value={tagName}
          />
          {error ? <p className="text-danger">{error}</p> : null}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() => onConfirm(tagName)}
          className="btn btnBlue"
          disabled={!!modalLoader}
        >
          {confirmButtonText}
        </Button>
        {modalLoader && <Loader />}
      </Modal.Footer>
    </Modal >
  );
};

TagNameModal.defaultProps = {
  onConfirm: () => { },
  onCancel: () => { },
  confirmButtonText: "Ok",
  confirmText: "",
  modalTitle: "Confirmation",
  cancelButtonText: "Cancel",
};
